import React from 'react';
import './cards.css';

function Cards({ Icon, title, info }) {
  return (
    <div className='cardblock'>
      <Icon fontSize='large' />
      <h4>{title}</h4>
      <p>{info}</p>
    </div>
  );
}

export default Cards;